import httpClient from '@/services/httpClient';
import * as routes from '@/config/routes';

const injectRouteParams = (route, params) => route.replace(/:(\w+)/g, (_, param) => params[param]);

export default {
  getMainPageContent() {
    return httpClient.get(routes.MAIN_PAGE);
  },

  getMainPageMedia() {
    return httpClient.get(routes.MAIN_PAGE_MEDIA);
  },

  getProcessPageContent() {
    return httpClient.get(routes.PROCESS_PAGE);
  },

  getPortfolio() {
    return httpClient.get(routes.PORTFOLIO);
  },

  getPortfolioDetails({ params }) {
    return httpClient.get(injectRouteParams(routes.PORTFOLIO_DETAILS, params));
  },

  getResources() {
    return httpClient.get(routes.RESOURCES);
  },

  getResourceDetails({ params }) {
    return httpClient.get(injectRouteParams(routes.RESOURCE_DETAILS, params));
  },

  getEmployees() {
    return httpClient.get(routes.EMPLOYEES);
  },

  sendContacts(data) {
    return httpClient.post(routes.CONTACT_US, data);
  },
};



// WEBPACK FOOTER //
// ./src/services/api.js